import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb'


const OpenLoopAndSceneExtract = () => {
    return (
        <div data-test='closedLoopAndSceneExtractComponent'>

            <Breadcrumb>
                <Breadcrumb.Item href="">
                    <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to='/welcome'>Welcome</Link>

                </Breadcrumb.Item>
                <Breadcrumb.Item href="/close_loop" active> Open loop</Breadcrumb.Item>
            </Breadcrumb>

            <div className="container" style={{ paddingTop: "5%" }}>
                <div className="card">
                    <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white", display: 'flex', justifyContent: 'space-between' }}>
                        <h1>{window.location.pathname === "/scene_extract" ?
                            "Scene Extract"
                            : "Open Loop"}</h1>
                    </div>
                    <div className="card-body">
                        <div className="container">
                            <div className="row" style={{ paddingTop: "2%" }}>
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <div style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                        <Link to='/open_loop_cm_fusion_data_collection_enhanced'>
                                                            Base Scenario Collection
                                                        </Link>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: "2%" }}>
                                        <div className="col-md-6">
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <div style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                        <Link to='/open_loop_cm_scenario_group' >
                                                            Scenario Group
                                                        </Link>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <div style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                            CAD Topology
                                                        
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="row" style={{ paddingTop: "2%" }}>
                                    <div className="col-md-12">
                                        <Link to="/scenario_variation/upload" >
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <h4 style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#622AD8" }}>
                                                        Scenario Variation Upload
                                                    </h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div> */}
                                    <div className="row" style={{ paddingTop: "2%" }}>
                                        <div className="col-md-6">
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <div style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                            KPI Dashboard
                                                    </div>
                                                    <div className='row'>
                                                        {/* <div className="col-md-6">
                                                        {selectedOption === "carla" && (
                                                            <Link to="/close_loop/individual/kpi/dashboard" >
                                                                <a style={{ float: "right", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                    Carla
                                                                </a>
                                                                  KPI Dashboard
                                                            </Link>
                                                        )}
                                                        </div>
                                                        <div className="col-md-6">
                                                        {selectedOption === "carmaker" && (
                                                            <a style={{ float: "left", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                Carmaker
                                                            </a>
                                                        )}
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <div style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                            Docker Stats
                                                    </div>
                                                    <div className='row'>
                                                        {/* <div className="col-md-6">
                                                        {selectedOption === "carla" && (
                                                            <Link to="/close_loop/real_time/apm/dashboard" >
                                                                <a style={{ float: "right", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                    Carla
                                                                </a>
                                                                Docker Stats
                                                            </Link>
                                                        )}
                                                        </div>
                                                        <div className="col-md-6">
                                                        {selectedOption === "carmaker" && (
                                                            <a style={{ float: "left", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                Carmaker
                                                            </a>
                                                        )}
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OpenLoopAndSceneExtract
